module.exports = __webpack_public_path__ + "img/Logo_Prym-Soft_pion.b6d0ef33.jpg";